import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../data/content";
import { Logo } from "../components/Logo";

export const Footer = () => (
  <footer className="border-t" style={{ borderColor: "var(--line)", background: "var(--bg-2)" }} data-testid="site-footer">
    <div className="msg-container py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <Logo size="lg" />
        <p className="mt-6 text-sm leading-relaxed" style={{ color: "var(--text-2)" }}>
          Full-service signage & display manufacturing in Woodbridge, Ontario. Design. Print. Fabricate. Install.
        </p>
      </div>
      <div>
        <h4 className="font-mono text-xs tracking-[0.2em] uppercase mb-5" style={{ color: "var(--text-3)" }}>Explore</h4>
        <ul className="space-y-3">
          {[["About Us", "/about"], ["Solutions", "/solutions"], ["Services", "/services"], ["Our Work", "/portfolio"], ["Infrastructure", "/infrastructure"]].map(([label, to]) => (
            <li key={to}>
              <Link to={to} className="text-sm inline-flex items-center gap-1 transition-colors hover:text-[var(--brand-cyan)]" style={{ color: "var(--text-2)" }} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}>
                {label} <ArrowUpRight size={12} />
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-mono text-xs tracking-[0.2em] uppercase mb-5" style={{ color: "var(--text-3)" }}>Solutions</h4>
        <ul className="space-y-3 text-sm" style={{ color: "var(--text-2)" }}>
          <li>POP / POS Displays</li>
          <li>Banners & Graphics</li>
          <li>Retail Displays</li>
          <li>Backlit Displays</li>
          <li>Window & Glass Graphics</li>
        </ul>
      </div>
      <div>
        <h4 className="font-mono text-xs tracking-[0.2em] uppercase mb-5" style={{ color: "var(--text-3)" }}>Contact</h4>
        <ul className="space-y-4 text-sm" style={{ color: "var(--text-2)" }}>
          <li className="flex gap-3" data-testid="footer-address"><MapPin size={16} className="shrink-0 mt-0.5" style={{ color: "var(--brand-orange)" }} />{COMPANY.address}</li>
          <li className="flex gap-3" data-testid="footer-phone"><Phone size={16} className="shrink-0 mt-0.5" style={{ color: "var(--brand-magenta)" }} /><a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-[var(--brand-cyan)]">{COMPANY.phone}</a></li>
          <li className="flex gap-3" data-testid="footer-email"><Mail size={16} className="shrink-0 mt-0.5" style={{ color: "var(--brand-cyan)" }} /><a href={`mailto:${COMPANY.email}`} className="hover:text-[var(--brand-cyan)]">{COMPANY.email}</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t" style={{ borderColor: "var(--line)" }}>
      <div className="msg-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[11px] tracking-wider uppercase" style={{ color: "var(--text-3)" }}>
          © {new Date().getFullYear()} MSG — Mark Signs & Graphics · msgsigns.ca
        </p>
        <p className="font-mono text-[11px] tracking-wider uppercase" style={{ color: "var(--text-3)" }}>
          Woodbridge · Ontario · Canada
        </p>
      </div>
    </div>
  </footer>
);
